// extracted by mini-css-extract-plugin
module.exports = {"wrapper_ThreeDMainBox":"styles_wrapper_ThreeDMainBox__1pu2L","wrapper_canvas":"styles_wrapper_canvas__2-hni"};